import {
	AfterViewInit,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Injectable,
	OnDestroy,
	OnInit,
	QueryList,
	Renderer2,
	ViewChild,
	ViewChildren,
} from "@angular/core";
import {LangChangeEvent, TranslateService, TranslatePipe} from "@ngx-translate/core";
import {TranslatableComponent}from "../../../../core/models/TranslatableComponent";
import {UntilDestroy} from "@ngneat/until-destroy";
import {ComponentCanDeactivate} from "../../../../core/guards/pending-changes.guard";
import {MatDialog} from "@angular/material/dialog";
import {AssetsUploadComponent} from "../../../../shared/dialogs/assets-upload/assets-upload.component";
import {ResourceRequestListService} from "../../services/resource-request-list.service";
import {FormControl, FormGroup, Validators, ReactiveFormsModule} from "@angular/forms";
// eslint-disable-next-line @typescript-eslint/naming-convention
import Config from "../../../../core/config/Config";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {firstValueFrom, map, Observable, Subscription} from "rxjs";
import {startWith, switchMap, take} from "rxjs/operators";
import {EmployeeService} from "../../../../core/services/services/employee.service";
import {EmployeeFileService} from "../../../../core/services/services/employeeFile.service";
import {clone, includes, isUndefined, startsWith} from "lodash";
import {
	EmployeeFullNameEmailStatus,
	OfferedEmployeesComponent,
} from "../../../../shared/dialogs/offered-employees/offered-employees.component";
import {FilesViewDialogComponent} from "../../../../shared/dialogs/files-view-dialog/files-view-dialog.component";
import {StaffingCommentDialogComponent} from "./staffing-comment-dialog/staffing-comment-dialog.component";
import moment from "moment/moment";
import {AuthenticationService} from "../../../../core/services/services/authentication.service";
import {CustomizingService} from "../../../../core/services/services/customizing.service";
import {AlertEnum} from "../../../../core/models/Enums/AlertEnum";
import {MessageService} from "../../../../core/services/services/message.service";
import {ResourceRequest} from "../../../../core/models/resource-request";
import {ImportRefreshService} from "../../../../core/services/services/importDialogRefresh.service";
import {Employee} from "../../../../core/models/Employee";
import {EmployeeSkill, Skill, SkillDbEntry, SkillWithMinimumLevel} from "../../../../core/models/EmployeeSkill";
import {RedesignSkillDbFilterData} from "../../../../shared/redesign-filter/redesign-filter.interface";
import {Client} from "../../../../core/config/Client";
import {FileDownloadService} from "../../../../core/services/services/file-download.service";
import {COMMA, ENTER, SEMICOLON} from "@angular/cdk/keycodes";
import {
	MatStepper,
	MatStepperIcon,
	MatStep,
	MatStepperNext,
	MatStepperPrevious,
} from "@angular/material/stepper";
import {PreferencesService} from "../../../../core/services/services/preferences.service";
import {ConfirmationDialogComponent} from "../../../../shared/dialogs/confirmation-dialog/confirmation-dialog.component";
import {
	AssignData,
	AssignEmployeeDialogComponent,
} from "../../../../shared/dialogs/assign-employee-dialog/assign-employee-dialog.component";
import {ProjectDataComponent} from "../../../../shared/project-data/project-data.component";
import {ProjectStatus} from "../../../../core/models/Enums/ProjectStatus";
import {Project} from "../../../../core/models/Project";
import {ResourceRequestFile} from "../../../../core/models/resource-request-file";
import {StaffingComment} from "../../../../core/models/staffing-comment";
import {EmployeeFullName} from "../../../../core/models/EmployeeFullName";
import {ApplicationUser} from "../../../../core/models/ApplicationUser";
import {Role} from "../../../../core/models/Role";
import {DropDownChoice} from "../../../employee-operations/abstract-employee-details.component";
import {ResourceRequestUpdateDTO} from "../../../../core/models/ResourceRequestUpdateDTO";
import {MatSelect} from "@angular/material/select";
import {MatCheckbox} from "@angular/material/checkbox";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {AppEntity, AppEntityAccessType, Permission} from "../../../../core/models/AppPermissions";
import {DivisionService} from "../../../../core/services/services/division.service";
import {CountryService} from "../../../../core/services/services/country.service";
import {OfferedEmployeeStatus} from "../../../../core/models/Enums/OfferedEmployeeStatus";
import {MisplannedCapacityEnum} from "../../../../core/models/Enums/MisplannedCapacityEnum";
// eslint-disable-next-line @typescript-eslint/naming-convention
import MarketUnit from "../../../../core/config/MarketUnit";
import {OfferedChangedStatus} from "../../../../core/models/OfferedChangedStatus";
import {AppearanceService} from "../../../../core/services/services/appearance.service";
import {GlobalService} from "../../../../core/services/services/global.service";
import {BreadcrumbsNavigationService} from "../../../../core/services/services/breadcrumbs-navigation.service";
import {NotifyResponsibleDialogComponent} from "../../../../shared/dialogs/notify-responsible-dialog/notify-responsible-dialog.component";
import {ProfileMapExtractionPopupComponent} from "./profile-map-extraction-popup/profile-map-extraction-popup.component";
import {BannerService} from "../../../../core/services/services/banner.service";
import {MessageBannerTemplate} from "../../../../core/components/information-banner/banners/simple-message-banner";
import {DataService} from "../../../../core/services/services/data.service";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {FavoriteResourceRequestDialogComponent} from "../../../../shared/dialogs/favorite-resource-request-dialog/favorite-resource-request-dialog.component";
import {MephistoUploadDialogComponent} from "./mephisto-upload-dialog/mephisto-upload-dialog.component";
import {PageNotFoundService} from "../../../../core/services/services/page-not-found.service";
import {DatePipe, NgClass, AsyncPipe, Location} from "@angular/common";
import {AssignmentProjectEmployee} from "../../../../core/models/AssignmentProjectEmployee";
import {MatProgressBar} from "@angular/material/progress-bar";
import {MatFormField, MatLabel, MatSuffix, MatError} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatTooltip} from "@angular/material/tooltip";
import {MatOption, MatAutocompleteTrigger, MatAutocomplete} from "@angular/material/autocomplete";
import {MepPopoverDirective} from "src/app/shared/mep-popover/mep-popover.directive";
import {MatIcon} from "@angular/material/icon";
import {RequiresPermissionDirective} from "../../../../shared/permission/directives/requires-permission.directive";
import {ProjectAutocompleteComponent} from "../../../../shared/autocomplete/components/project-autocomplete.component";
import {RedesignSkillFilterComponent} from "../../../../shared/redesign-filter/redesign-skill-filter/redesign-skill-filter.component";
import {EmployeeAutocompleteComponent} from "../../../../shared/autocomplete/components/employee-autocomplete.component";
import {OnlyIntegerDirective} from "../../../../shared/inputdirectives/only-integer.directive";
import {MatButton} from "@angular/material/button";
import {ListPickerComponent} from "./list-picker/list-picker.component";
import {CommaDecimalPatternDirective} from "../../../../shared/inputdirectives/comma-decimal-pattern-directive";
import {MatChipGrid, MatChipRow, MatChipRemove, MatChipInput} from "@angular/material/chips";
import {SelectSearchComponent} from "../../../../shared/select-search/select-search.component";
import {LanguageEnum} from "src/app/core/models/Enums/LanguageEnum";

const objectValidator = (control) => {
	if (control.value?.toString().trim().length === 0) {
		control.setValue(null);
	}
	return typeof control.value !== "object" ? {invalidEmployee: true} : null;
};

const employeeDisplayFn = (employee: string | EmployeeFullName) => {
	if (!employee) {
		return "";
	}
	if (typeof employee !== "string" && employee.firstName && employee.lastName) {
		return employee.firstName + " " + employee.lastName;
	}
	return employee.toString();
};

interface AutocompleteType<T> {
	original: Promise<T[]>;
	filtered: Observable<T[]>;
	display?: (value: T | string) => string;
	displayDropdown?: (value: T) => string;
}

@Injectable({providedIn: "root"})
@UntilDestroy()
@Component({
	selector: "app-add-resource-request",
	templateUrl: "./add-resource-request.component.html",
	styleUrls: ["./add-resource-request.component.scss"],
	animations: [
		trigger("fieldsPopUpAnimation", [
			state(
				"hidden",
				style({
					width: 0,
					opacity: 0,
					overflow: "hidden",
					transform: "translateY(-3rem)",
				}),
			),
			state(
				"visible",
				style({
					width: "45%",
					opacity: 2,
					transform: "translateY(0)",
				}),
			),
			transition("hidden => visible", [animate("1s ease-in-out")]),
			transition("visible => hidden", [animate("1s ease-in-out")]),
		]),
	],
	imports: [
		MatProgressBar,
		ReactiveFormsModule,
		MatFormField,
		MatLabel,
		MatInput,
		MatDatepickerInput,
		MatDatepickerToggle,
		MatSuffix,
		MatDatepicker,
		MatTooltip,
		MatSelect,
		MatOption,
		MepPopoverDirective,
		MatCheckbox,
		MatIcon,
		NgClass,
		RequiresPermissionDirective,
		MatStepper,
		MatStepperIcon,
		MatStep,
		MatAutocompleteTrigger,
		MatAutocomplete,
		ProjectAutocompleteComponent,
		RedesignSkillFilterComponent,
		EmployeeAutocompleteComponent,
		OnlyIntegerDirective,
		MatButton,
		ListPickerComponent,
		MatStepperNext,
		MatError,
		CommaDecimalPatternDirective,
		MatStepperPrevious,
		MatChipGrid,
		MatChipRow,
		MatChipRemove,
		MatChipInput,
		SelectSearchComponent,
		AsyncPipe,
		DatePipe,
		TranslatePipe,
	],
})
export class AddResourceRequestComponent
	extends TranslatableComponent
	implements OnInit, ComponentCanDeactivate, AfterViewInit, OnDestroy
{
	// region variables
	@ViewChild("stepper") stepper: MatStepper;
	@ViewChildren(MatSelect) matSelects: QueryList<MatSelect>;
	@ViewChildren(MatCheckbox) matCheckboxes: QueryList<MatCheckbox>;
	@ViewChildren(MatDatepicker) matDatePickers: QueryList<MatDatepicker<never>>;

	resourceRequestId: number;

	onSkillsLoad = new EventEmitter<RedesignSkillDbFilterData>();
	departmentCustomizing = {
		isMsgServices: false,
		isGBP: false,
	};
	lists = {
		files: [] as ResourceRequestFile[],
		offers: [] as EmployeeFullNameEmailStatus[],
		staffingComments: [] as StaffingComment[],
		interestedStaffingComments: [] as StaffingComment[],
		interestedResponsible: [] as EmployeeFullNameEmailStatus[],
		staffingTags: [] as string[],
	};
	listEmitters = {
		offers: new EventEmitter<EmployeeFullNameEmailStatus[]>(),
		files: new EventEmitter<ResourceRequestFile[]>(),
		staffingComments: new EventEmitter<StaffingComment[]>(),
		interestedStaffingComments: new EventEmitter<StaffingComment[]>(),
		interestedResponsible: new EventEmitter<EmployeeFullNameEmailStatus[]>(),
	};
	separatorKeysCodes: number[] = [ENTER, COMMA, SEMICOLON];
	// someone could change this to one Form group...
	formGroups = {
		f0Header: new FormGroup({
			origId: new FormControl(),
			requestTitle: new FormControl("", Validators.required),
			commitmentStart: new FormControl("", Validators.required),
			commitmentEnd: new FormControl(""),
			requestType: new FormControl("", Validators.required),
			probability: new FormControl(),
			requestStatus: new FormControl("", Validators.required),
			resubmissionDate: new FormControl(""),
			statusComment: new FormControl(""),
			dispoFlag: new FormControl(false),
		}),
		f1CustomerData: new FormGroup({
			client: new FormControl("", Validators.required),
			currentProject: new FormControl<Project>(null, objectValidator),
			countryOfStaffing: new FormControl([]),
			requiredLanguage: new FormControl([]),
			internalSkillset: new FormControl<SkillDbEntry[]>([]),
			skillOperator: new FormControl("AND"),
			skillDescriptionOfCustomer: new FormControl(""),
			notes: new FormControl(""),
			files: new FormControl(),
			requiredEmployees: new FormControl(null, Validators.required),
			desiredCandidate: new FormControl(""),
			optionOnFollowUpBusiness: new FormControl(false),
			offer: new FormControl(""),
			role: new FormControl(""),
		}),
		f2FrameData: new FormGroup({
			requestingUnit: new FormControl("", Validators.required),
			requestedBy: new FormControl("", Validators.required),
			requestedFrom: new FormControl(null, {
				validators: [objectValidator, Validators.required],
			}),
			compensation: new FormControl(),
			currency: new FormControl(null),
			ratesDetails: new FormControl(""),
			travelExpensePolicy: new FormControl(""),
			scope: new FormControl(null, Validators.required),
			totalScope: new FormControl(),
			scopeComment: new FormControl(),
			location: new FormControl(""),
			travelMode: new FormControl(null),
			travelModeDetails: new FormControl(""),
		}),
		f3InternalHistory: new FormGroup({
			divisions: new FormControl<string[]>([]),
			responsibleBusinessUnit: new FormControl(null, Validators.required),
			requestReceipt: new FormControl("", Validators.required),
			answerUntil: new FormControl("", Validators.required),
			offered: new FormControl([]),
			staffingTag: new FormControl(""),
			responsibleDE: new FormControl(null, {
				validators: [objectValidator, Validators.required],
			}),
			responsibleRO: new FormControl(null, objectValidator),
			staffingComments: new FormControl([]),
			interestedResponsible: new FormControl([]),
			// businessUnits == Interested Business Units in the UI
			businessUnits: new FormControl([]),
			interestedStaffingComments: new FormControl([]),
		}),
	};
	options = {
		probability: this.getEnumsTranslated(Config.services.resource_request.probability),
		requestType: this.getEnums(Config.services.resource_request.request_type),
		status: this.getEnums(Config.services.resource_request.status),
		countryOfStaffing: this.getEnums(Config.services.resource_request.staffingLocation),
		requiredLanguage: this.getEnums(Config.services.resource_request.requiredLanguage),
		currency: this.getEnums(Config.services.employees.currency),
		travelMode: this.getEnums(Config.services.resource_request.travelMode),
		businessUnit: null as DropDownChoice<string>[],
		responsibleBusinessUnitDropDown: null as DropDownChoice<string>[],
		division: null as DropDownChoice<string>[],
	};
	addMode: boolean;
	loading: boolean;
	permissionsLoaded = new EventEmitter<boolean>();
	resourceRequestCreated = new EventEmitter<boolean>();
	resourceRequest: ResourceRequest;
	autocomplete = {
		client: {
			original: firstValueFrom(this._resourceRequestListService.getResourceRequestClients()),
			filtered: null,
		} as AutocompleteType<string>,
		requestingUnit: {
			original: firstValueFrom(this._resourceRequestListService.getResourceRequestRequestingUnits()),
			filtered: null,
		} as AutocompleteType<string>,
		staffingTag: {
			original: firstValueFrom(this._resourceRequestListService.getStaffingTags()),
			filtered: null,
		} as AutocompleteType<string>,
	};
	isMultiResourceRequestSafeMode = false;
	permissions = {
		isForeignBUsRR: false,
		isOtherInstance: false,
		hasInterestedBUWritePermissionsOnly: false,
		hasGeneralWritePermissions: false,
		hasReadOnConfidentialFields: true,
		showExperimentalMEPTextextraction: false,
		isAdmin: false,
	};
	hasReadOnlyRole: boolean = true;
	isOwnerOfRR: boolean;
	businessUnitFieldsRefresh: boolean = false;

	chatBotEnabled: boolean;
	staffingAutofillEnabled: boolean;
	applicationUser: ApplicationUser;

	private rendered = false;
	private listMaxLength = 100;
	private saving = false;
	private canExit = false;
	private currentUser: ApplicationUser;
	currentUserIsMA: boolean;
	private currentClient: Client;
	private allowedControls: Record<string, FormControl>;

	protected readonly marketUnit = MarketUnit;
	protected readonly offeredEmployeeStatus = OfferedEmployeeStatus;
	filteredOptions: Record<string, DropDownChoice<string>[]> = {};
	offeredEmployeeStatusSelection = this.getEnums(OfferedEmployeeStatus);
	private offeredStatusChange: OfferedChangedStatus;
	private buAllowlist: string[];
	private instanceNameOfRR: any;
	businessUnitsOfUser: string[];
	selectedSkills: SkillDbEntry[] = [];

	isTypeTask: boolean = false;

	showFavoriteButton = false;
	isFavoriteResourceRequestOfUser: boolean = false;
	favoriteCommentWhileAdding: string;

	public noEditingAfterResponsibleChange = false;
	private openBanner: number;

	private optionSelected: boolean;
	private resourceRequestPromise: Promise<ResourceRequest>;
	lang = "de";
	private readonly profileViewButtonRoles = [
		Role.PROJECT_ADMIN,
		Role.DEPARTMENT_MANAGER,
		Role.DIVISION_MANAGER,
		Role.BUSINESS_UNIT_MANAGER,
		Role.BUSINESS_UNIT_LEADER,
		Role.MEP_ADMIN,
	];
	private offeredEmployeeIdsWithFiles = new Set<number>();
	private offerFileAvailabilityRequestId = 0;

	constructor(
		public _translate: TranslateService,
		public _dialog: MatDialog,
		private _resourceRequestService: ResourceRequestListService,
		private _resourceRequestListService: ResourceRequestListService,
		private _activatedRoute: ActivatedRoute,
		private _employeeService: EmployeeService,
		private _employeeFileService: EmployeeFileService,
		private _authService: AuthenticationService,
		private _customizingService: CustomizingService,
		private _globalService: GlobalService,
		private _messageService: MessageService,
		private _router: Router,
		private _importRefreshService: ImportRefreshService,
		private _fileDownloadService: FileDownloadService,
		private _prefService: PreferencesService,
		private renderer: Renderer2,
		private _divisionService: DivisionService,
		private _countryService: CountryService,
		private cd: ChangeDetectorRef,
		private _dataService: DataService,
		private breadCrumbsNavigationService: BreadcrumbsNavigationService,
		private bannerService: BannerService,
		private _activateRoute: ActivatedRoute,
		private pageNotFoundService: PageNotFoundService,
		private _location: Location,
		private appearanceService: AppearanceService,
		private datePipe: DatePipe,
	) {
		super(_translate, "AddResourceRequestComponent");

		if (this._activatedRoute.snapshot && this._activatedRoute.snapshot.params["resourceRequestId"]) {
			this.resourceRequestPromise = this.getResourceRequest();

			this.resourceRequestPromise.then((value) => {
				if (isUndefined(value?.id)) {
					this.pageNotFoundService
						.navigateTo({
							status: 404,
							type: "RR",
							action: "/resource-request-list",
						})
						.then();
				}
			});
		}

		const nav = this._router.getCurrentNavigation();
		const preAssignedData = nav?.extras?.state;

		if (preAssignedData?.project) {
			this.preAssignValuesFromProjectDetails(preAssignedData.project, preAssignedData.selectedAssignment);
		}
	}

	private _isFormEditable: boolean;

	get isFormEditable() {
		return this._isFormEditable;
	}

	/**
	 * makes the form editable or readonly
	 *
	 * takes "allowedControls" into account
	 */
	set isFormEditable(isFormEditable: boolean) {
		this._isFormEditable = isFormEditable;

		if (this._isFormEditable) {
			if (this.allowedControls) {
				for (let allowedControlsKey in this.allowedControls) {
					this.allowedControls[allowedControlsKey].enable({emitEvent: false});
				}
			}
		} else {
			this.formGroups.f0Header.disable({emitEvent: false});
			this.formGroups.f1CustomerData.disable({emitEvent: false});
			this.formGroups.f2FrameData.disable({emitEvent: false});
			this.formGroups.f3InternalHistory.disable({emitEvent: false});
		}
	}

	get isStatusCommentVisible() {
		return (
			this.formGroups.f0Header.controls.requestStatus.value === "CLIENT_DISCARDED" ||
			this.formGroups.f0Header.controls.requestStatus.value === "CLIENT_OFFER_DECLINED" ||
			this.formGroups.f0Header.controls.requestStatus.value === "DECLINED"
		);
	}

	private updateStatusCommentValidator() {
		const statusCommentControl = this.formGroups.f0Header.controls.statusComment;
		if (this.isStatusCommentVisible) {
			statusCommentControl.setValidators([Validators.required]);
		} else {
			statusCommentControl.clearValidators();
		}
		statusCommentControl.updateValueAndValidity();
	}

	private isFinalRequestStatus(status: string): boolean {
		return (
			status === "DECLINED" ||
			status === "CLIENT_DISCARDED" ||
			status === "CLIENT_OFFER_ACEPTED" ||
			status === "CLIENT_OFFER_DECLINED"
		);
	}

	/**
	 * Mirrors the backend logic (ResourceRequestService#updateResourceRequestStatus): once the
	 * request reaches a final status, the dispo flag is cleared. Update the form control and the
	 * underlying resourceRequest so the checkbox and the share-staffing button hide immediately.
	 */
	private clearDispoFlagIfFinalStatus(status: string) {
		if (!this.isFinalRequestStatus(status)) {
			return;
		}
		const dispoFlagControl = this.formGroups.f0Header.controls.dispoFlag;
		if (dispoFlagControl.value) {
			dispoFlagControl.setValue(false);
		}
		if (this.resourceRequest?.dispoFlag) {
			this.resourceRequest.dispoFlag = false;
			this.resourceRequest.dispoFlagLastChangedAt = moment().format("YYYY-MM-DD");
		}
	}

	get disabled() {
		return this.loading || this.saving || !this.isFormEditable || this.permissions.hasInterestedBUWritePermissionsOnly;
	}

	getSubmitButtonLabel() {
		if (this.loading) {
			return this._lang("loading");
		}
		if (this.saving) {
			return this._lang("saving");
		}
		if (!this.permissions.hasGeneralWritePermissions) {
			return this._lang("no-permission");
		}
		if (
			!this.addMode &&
			this.formGroups.f0Header.pristine &&
			this.formGroups.f1CustomerData.pristine &&
			this.formGroups.f2FrameData.pristine &&
			this.formGroups.f3InternalHistory.pristine
		) {
			return this._lang("no-changes");
		}
		if (this.addMode) {
			return this._lang("create");
		}
		return this._lang("update");
	}

	isSubmitButtonDisabled() {
		return (
			this.saving ||
			this.loading ||
			(this.formGroups.f0Header.pristine &&
				this.formGroups.f1CustomerData.pristine &&
				this.formGroups.f2FrameData.pristine &&
				this.formGroups.f3InternalHistory.pristine)
		);
	}

	async updateInterestedFields(event) {
		if (!this.addMode) {
			this.lists.staffingComments = [];
			this.lists.interestedStaffingComments = [];
			this.noEditingAfterResponsibleChange =
				!this.permissions.hasGeneralWritePermissions ||
				(this.permissions.hasReadOnConfidentialFields && event.value !== this.resourceRequest.responsibleBusinessUnit);
			this.businessUnitFieldsRefresh = true;
			this.loading = true;

			let currentUserBU: string;
			if (this.currentUser.employee != null) {
				currentUserBU = this.currentUser.employee.businessUnit;
			} else {
				currentUserBU = await this._employeeService.getBusinessUnitFromKeycloak();
			}

			if (currentUserBU) {
				setTimeout(() => {
					this.businessUnitFieldsRefresh = false;
					this.loading = false;
					this.submit().then();
				});
			}
		}
	}

	onSearchSelectFiltered(key: string, options: DropDownChoice<string>[]) {
		this.filteredOptions[key] = options;
		this.cd.detectChanges();
	}

	//#endregion

	// eslint-disable-next-line @angular-eslint/contextual-lifecycle
	async ngOnInit() {
		this.currentUser = await this._authService.getApplicationUser();
		this.currentUserIsMA = await (this._authService.hasMaSkillAndAssignmentEditRole() ||
			this._authService.hasMaSkillEditRole());
		this.allowedControls = {
			...this.formGroups.f0Header.controls,
			...this.formGroups.f1CustomerData.controls,
			...this.formGroups.f2FrameData.controls,
			...this.formGroups.f3InternalHistory.controls,
		};
		delete this.allowedControls["origId"];

		this.lang = this.appearanceService.getLanguage();
		this.translate.onLangChange.subscribe((event) => this.onLangChanged(event));

		// load countries of staffing
		this.options.countryOfStaffing = await this.getCountryOfStaffing();

		this.formGroups.f0Header.controls.requestStatus.valueChanges.subscribe((value) => {
			if (value === "FOLLOW_UP") {
				this.formGroups.f0Header.controls.resubmissionDate.addValidators(Validators.required);
				this.formGroups.f0Header.controls.resubmissionDate.updateValueAndValidity({emitEvent: false});
			} else {
				this.formGroups.f0Header.controls.resubmissionDate.removeValidators(Validators.required);
				this.formGroups.f0Header.controls.resubmissionDate.updateValueAndValidity({emitEvent: false});
			}
		});

		this.loading = true;
		this.isFormEditable = false;

		await this.loadDefaultForm()
			.then(async () => {
				this.chatBotEnabled = await this._customizingService.getChatBotCustomizing(this.currentUser);
				this.staffingAutofillEnabled = await this._customizingService.getStaffingAutofillCustomizing(this.currentUser);

				this.generateAutocompleteFilterLists(
					this.autocomplete.client,
					this.formGroups.f1CustomerData.controls.client.valueChanges,
				);
				this.generateAutocompleteFilterLists(
					this.autocomplete.requestingUnit,
					this.formGroups.f2FrameData.controls.requestingUnit.valueChanges,
				);
				this.generateAutocompleteFilterLists(
					this.autocomplete.staffingTag,
					this.formGroups.f3InternalHistory.controls.staffingTag.valueChanges,
				);

				this.businessUnitsOfUser = await this._employeeService.getBusinessUnits(false);
				if (this.businessUnitsOfUser.length === 0 && this.currentUser?.employee?.businessUnit) {
					this.businessUnitsOfUser.push(this.currentUser.employee.businessUnit);
				}

				this.currentClient = await this._customizingService.getCurrentClient();
				this.buAllowlist = await this._customizingService.getBusinessUnitAllowlistEmployees();
				this.departmentCustomizing.isMsgServices = this.currentClient === Client.MSG_SERVICES;
				this.departmentCustomizing.isGBP = this.currentClient === Client.GBP;

				this._resourceRequestService.fetchBusinessUnitOptions().then((values) => {
					this.options.businessUnit = values;
					this.options.responsibleBusinessUnitDropDown = values;
				});

				this.options.division = await this._divisionService.getDivisionOptionsByBusinessUnit([
					this.formGroups.f3InternalHistory.controls.responsibleBusinessUnit.value,
				]);
				if (this.addMode) {
					// this is being done by submitOnChanges in CreateMode
					this.formGroups.f3InternalHistory.controls.responsibleBusinessUnit.valueChanges.subscribe(() =>
						this.updateAllowedDivisions(),
					);
				}

				await this.updatePermission();

				if (this.permissions.hasInterestedBUWritePermissionsOnly) {
					await this.updateInterestedBuDropdown();
					await this.disableFieldsBasedOnPermissionAndDispoFlag();
				}

				this.formGroups.f0Header.controls.requestStatus.valueChanges.subscribe((value) => {
					this.updateStatusCommentValidator();
					this.clearDispoFlagIfFinalStatus(value);
				});

				if (!this.addMode) {
					if (!this._activatedRoute.snapshot.params["instance"]) {
						this.showFavoriteButton = true;
						this.isFavoriteResourceRequestOfUser = await firstValueFrom(
							this._resourceRequestService.checkIfFavorite(this.resourceRequest.id),
						);
					}

					// Handles Autosave in Editing Mode
					this.submitOnChanges();

					// Handles the Navigation through the Details
					this.breadCrumbsNavigationService.openThroughDetail(this, this.resourceRequest.id, "resourceRequest");
					this.breadCrumbsNavigationService.setInDetails(true);

					this.checkIfBannerNeeded();
				} else {
					this.showFavoriteButton = true;
					if (this.currentUserIsMA) {
						this.isMaOnAddMode();
					}
				}

				this.loading = false;
				this.isFormEditable = true;
			})
			.catch(() => {
				return;
			});
	}

	async onLangChanged(event: LangChangeEvent) {
		this.lang = event.lang;
		this.options.countryOfStaffing = await this.getCountryOfStaffing();
	}

	markAsFavorite() {
		this.isFavoriteResourceRequestOfUser = !this.isFavoriteResourceRequestOfUser;
		const dialog = this.isFavoriteResourceRequestOfUser
			? this._dialog.open(FavoriteResourceRequestDialogComponent)
			: null;
		if (!this.addMode) {
			dialog?.afterClosed().subscribe((comment) => {
				this._resourceRequestService
					.updateResourceRequestFavorite(this.resourceRequest.id, true, comment ?? null)
					.subscribe();
			});
			if (!dialog) {
				this._resourceRequestService.updateResourceRequestFavorite(this.resourceRequest.id, false, null).subscribe();
			}
		} else {
			dialog?.afterClosed().subscribe((comment) => {
				this.favoriteCommentWhileAdding = comment ?? null;
			});
			firstValueFrom(this.resourceRequestCreated).then(async () => {
				if (this.isFavoriteResourceRequestOfUser) {
					this._resourceRequestService
						.updateResourceRequestFavorite(this.resourceRequest.id, true, this.favoriteCommentWhileAdding)
						.subscribe();
				}
			});
		}
	}

	isMaOnAddMode() {
		this.formGroups.f0Header.controls.requestType.setValue("TASK");
		this.checkIfBannerNeeded("TASK");
	}

	loadDefaultValuesForTask() {
		if (!this.formGroups.f1CustomerData.controls.client.value) {
			this.formGroups.f1CustomerData.controls.client.setValue("intern");
		}
		if (!this.formGroups.f2FrameData.controls.requestedBy.value) {
			this.formGroups.f2FrameData.controls.requestedBy.setValue(
				this.currentUser.employee.firstName + " " + this.currentUser.employee.lastName,
			);
		}
		if (!this.formGroups.f1CustomerData.controls.requiredEmployees.value) {
			this.formGroups.f1CustomerData.controls.requiredEmployees.setValue(1);
		}
		if (!this.formGroups.f2FrameData.controls.scope.value) {
			this.formGroups.f2FrameData.controls.scope.setValue(100);
		}
	}

	checkIfBannerNeeded(requestType?: string) {
		if (this.openBanner !== undefined) {
			this.bannerService.removeBanner(this.openBanner);
		}
		const type = requestType || this.resourceRequest.requestType;
		if (type === "FMA" || type === "TASK") {
			const bannerMsg = type === "FMA" ? this._lang("banner-info-fma") : this._lang("banner-info-task");

			this.openBanner = this.bannerService.createBanner({
				height: "6rem",
				template: new MessageBannerTemplate(
					{
						type: "information",
						msg: bannerMsg,
						style: {
							largeText: true,
						},
					},
					this._prefService,
				),
			});
		}

		if (type === "TASK") {
			this.isTypeTask = true;
			if (this.addMode) {
				this.loadDefaultValuesForTask();
			}
		} else {
			this.isTypeTask = false;
		}
	}

	async updatePermission() {
		if (!this.addMode) {
			// showMEPTextextraction is Experimantal and only for admins
			this.permissions.showExperimentalMEPTextextraction = this._authService.isMepAdmin();
			this.permissions.isAdmin = this.permissions.showExperimentalMEPTextextraction;
			// Global RR's are from a different Instance and can't be edited
			//this.permissions.isGlobalRR = !!this._activatedRoute.snapshot.params['instance'];
			if (this._activatedRoute.snapshot.params["instance"]) {
				this.permissions.isOtherInstance =
					this._activatedRoute.snapshot.params["instance"] !==
					(await firstValueFrom(this._globalService.getLocalInstanceName()));
			}
			// If the RR's Responsible BU is not assosiated w/ the user
			this.permissions.isForeignBUsRR = !this.businessUnitsOfUser.includes(
				this.formGroups.f3InternalHistory.controls.responsibleBusinessUnit.value,
			);

			this.permissions.hasReadOnConfidentialFields =
				(await this._authService.hasPermission(
					Permission.TRUE,
					AppEntityAccessType.READ,
					AppEntity.RESOURCE_REQUEST_CONFIDENTIAL_FIELDS,
				)) && !this.permissions.isForeignBUsRR;

			this.permissions.hasGeneralWritePermissions =
				!this.permissions.isOtherInstance &&
				// If the user has no Permission to read Confidential Fields, they can't write any Fields, as defined in Roles
				(this.permissions.hasReadOnConfidentialFields || (this.isTypeTask && this.currentUserIsMA));

			if (!this.permissions.hasGeneralWritePermissions || this.permissions.isOtherInstance) {
				this.allowedControls = {};
			}

			if (this.permissions.isForeignBUsRR && !this.permissions.isOtherInstance) {
				this.allowedControls = {
					businessUnits: this.formGroups.f3InternalHistory.controls.businessUnits,
					interestedResponsible: this.formGroups.f3InternalHistory.controls.interestedResponsible,
					interestedStaffingComments: this.formGroups.f3InternalHistory.controls.interestedStaffingComments,
					offered: this.formGroups.f3InternalHistory.controls.offered,
				};
				this.permissions.hasInterestedBUWritePermissionsOnly = true;
			}
			this.permissionsLoaded.emit(true);
		}

		this.hasReadOnlyRole =
			this.permissions.isOtherInstance ||
			((this._authService.hasMaSkillEditRole() || this._authService.hasMaSkillAndAssignmentEditRole()) &&
				this.resourceRequest.requestType !== "TASK") ||
			this._authService.hasExternalRole();

		this.isOwnerOfRR = this.resourceRequest.createdBy === this.currentUser.username;
		//#endregion
	}

	openTeamsChat(resId: number) {
		this._employeeService.fetchEmployeeEmailByID(resId).subscribe((email: string) => {
			if (email) {
				const teamsLink = `MSTeams:/l/chat/0/0?users=${email}`;
				window.location.href = teamsLink;
			}
		});
	}

	sendMailTo(resId: number) {
		this._employeeService.fetchEmployeeEmailByID(resId).subscribe((email: string) => {
			if (email) {
				const emailLink = `mailto:${email}`;
				window.location.href = emailLink;
			}
		});
	}

	ngOnDestroy() {
		this.bannerService.removeBanner(this.openBanner);
		this.breadCrumbsNavigationService.setInDetails(false);
	}

	async updateAllowedDivisions() {
		// divisions are filtered by business units
		this.options.division = await this._divisionService.getDivisionOptionsByBusinessUnit([
			this.formGroups.f3InternalHistory.controls.responsibleBusinessUnit.value,
		]);
		let div = this.formGroups.f3InternalHistory.controls.divisions;
		div.setValue(
			div.value.filter((val) => this.options.division.map((d) => d.value).includes(val)),
			{emitEvent: false},
		);
	}

	async updateInterestedBuDropdown() {
		let userBus = await this._employeeService.getBusinessUnits(false);
		const filteredBus = this.options.businessUnit.filter((bu) => userBus.includes(bu.value));
		this.options.businessUnit = filteredBus;
	}

	/**
	 * submits the RR on every change
	 */
	submitOnChanges() {
		let controls = this.allowedControls;

		for (let controlName in controls) {
			let control = controls[controlName];
			let nativeElement = document.querySelector(`[formcontrolname=${controlName}]`);
			let onInputEndSubscription: Subscription;

			control.valueChanges.subscribe(async () => {
				//#region checks if submit is even desired

				if (
					control.value === this.resourceRequest[controlName] ||
					(Array.isArray(control.value) &&
						this.resourceRequest[controlName] &&
						this.resourceRequest[controlName].length === control.value.length &&
						this.resourceRequest[controlName].every((value, index) => value === control.value[index])) ||
					(typeof control.value === "object" &&
						control.value?.id &&
						control.value?.id === this.resourceRequest[controlName]?.id)
				) {
					// untouched check
					control.markAsUntouched();
					control.markAsPristine();
					if (nativeElement && nativeElement.eventListeners("focusout").length > 0) {
						nativeElement.removeEventListener("focusout", nativeElement.eventListeners("focusout")[0]);
					}
					if (onInputEndSubscription) {
						onInputEndSubscription.unsubscribe();
					}
					return;
				}

				if (control.invalid) {
					return;
				}
				if (onInputEndSubscription && !onInputEndSubscription.closed) {
					return;
				}
				//#endregion

				//#region custom components and form fields that don't work w/ a focusout listener

				if (
					[
						"skillOperator",
						"internalSkillset",
						"staffingComments",
						"interestedStaffingComments",
						"interestedResponsible",
						"offered",
						"files",
					].includes(controlName)
				) {
					this.submit().then();
					return;
				}

				if (controlName === "staffingTag") {
					//  the staffing Tag component has its own submit function
					return;
				}

				if (controlName === "resubmissionDate" && this.allowedControls.requestStatus?.value === "FOLLOW_UP") {
					// has to be done cause this control's Validator is dynamic and without this 'resubmissionDate'
					// needs to be changed twice to update
					control.updateValueAndValidity({emitEvent: false});
				}

				if (!nativeElement) {
					// if there is no nativeElement (twice), the control is probably a custom component like the list picker
					nativeElement = document.querySelector(`[formcontrolname=${controlName}]`);
					if (!nativeElement) {
						return;
					}
				}

				if (nativeElement.attributes["data-mat-calendar"]) {
					// if a datepicker is assigned to the control
					// since resubmissionDate is created Dynamically and datepicker is numbered,
					// we need to update the attributes
					nativeElement = document.querySelector(`[formcontrolname=${controlName}]`);
					let datepicker = this.matDatePickers.find(
						(item) => item.id === nativeElement.attributes["data-mat-calendar"].nodeValue,
					);

					if (datepicker?.opened) {
						if (["commitmentStart", "commitmentEnd"].includes(controlName)) {
							await this.updateNumberOfPersonDays(false);
						}

						this.submit().then();
						return;
					}
				}

				if (nativeElement.tagName === "MAT-CHECKBOX") {
					await this.submit();
					return;
				}

				if (nativeElement.tagName === "MAT-SELECT") {
					onInputEndSubscription = this.matSelects
						.find((item) => item._elementRef.nativeElement === nativeElement)
						?._closedStream.subscribe(async () => {
							if (controlName === "responsibleBusinessUnit") {
								await this.updateAllowedDivisions();
							}
							this.submit().then();
							onInputEndSubscription.unsubscribe();
						});
					return;
				}
				//#endregion

				//#region creating a focusout Listener

				onInputEndSubscription = new Observable((subscriber) => {
					nativeElement.addEventListener("focusout", async () => {
						subscriber.next(undefined);
						// wouldn't want to submit twice
						nativeElement.removeEventListener("focusout", nativeElement.eventListeners("focusout")[0]);
						subscriber.complete();
					});
				}).subscribe(async () => {
					if (["scope", "requiredEmployees"].includes(controlName)) {
						await this.updateNumberOfPersonDays(false);
					}
					this.submit().then();
				});
				//#endregion
			});
		}
	}

	async loadDefaultForm(): Promise<void> {
		if (this._activatedRoute.snapshot && this._activatedRoute.snapshot.params["resourceRequestId"]) {
			this.addMode = false;

			this.resourceRequest = await this.resourceRequestPromise;
			// map countryOfStaffing
			this.resourceRequest.countryOfStaffing = this.resourceRequest.staffingLocation || null;

			if (!this.resourceRequest) {
				return Promise.reject();
			}

			let patchedResourceRequest = {
				...this.resourceRequest,
				staffingTag: "",
				internalSkillset: this.resourceRequest.internalSkillset.map(
					(skill) =>
						({
							skillNameDe: skill.skill.skillNameDe,
							skillNameEn: skill.skill.skillNameEn,
							skillNameAlt: skill.skill.skillNameAlt,
							level: skill.minimumLevel,
							original: skill.skill,
						}) as SkillDbEntry,
				),
			};

			this.isTypeTask = this.resourceRequest.requestType === "TASK";

			this.formGroups.f0Header.patchValue(patchedResourceRequest);
			this.formGroups.f1CustomerData.patchValue(patchedResourceRequest);
			this.formGroups.f2FrameData.patchValue(patchedResourceRequest);
			this.formGroups.f3InternalHistory.patchValue(patchedResourceRequest);

			if (patchedResourceRequest.offered) {
				this.lists.offers.push(
					...patchedResourceRequest.offered.map((value) => ({
						...value.employee,
						firstName: value.employee.firstName,
						lastName: value.employee.lastName,
						id: value.employee.id,
						email: value.employee.email,
						offeredStatus: value.offeredStatus ? value.offeredStatus : OfferedEmployeeStatus.PROFILE_IDEA,
						offeredEmployeeBu: value.offeredEmployeeBu,
						createdByUser: value.createdByUser,
						enableDownload: value.enableDownload ?? false,
						humanResourcesManager: value.employee.humanResourcesManager,
						declarationOfConsentCustomers: value.employee.declarationOfConsentCustomers,
						declarationOfConsentEntities: value.employee.declarationOfConsentEntities,
					})),
				);
			}
			if (patchedResourceRequest.staffingComments) {
				this.lists.staffingComments.push(...patchedResourceRequest.staffingComments);
			}
			if (patchedResourceRequest.interestedStaffingComments) {
				this.lists.interestedStaffingComments.push(...patchedResourceRequest.interestedStaffingComments);
			}
			if (patchedResourceRequest.interestedResponsible) {
				this.lists.interestedResponsible.push(
					...patchedResourceRequest.interestedResponsible.map((employee) => ({
						...employee,
						firstName: employee.firstName,
						lastName: employee.lastName,
						id: employee.id,
						email: employee.email,
						offeredEmployeeBu: employee.businessUnit,
						createdByUser: null,
					})),
				);
			}
			this.lists.staffingTags.push(
				...this.resourceRequest.staffingTag
					.split(",")
					.map((tag) => tag.trim())
					.filter((tag) => tag.length > 0),
			);
			firstValueFrom(this.permissionsLoaded).then(async () => {
				if (this.permissions.hasReadOnConfidentialFields) {
					this.lists.files.push(
						...(await firstValueFrom(
							this._resourceRequestService.getResourceRequestFiles(this.resourceRequest.id, false),
						)),
					);
					this.listEmitters.files.emit(this.lists.files);
				} else {
					this.lists.files.push(
						...(await firstValueFrom(
							this._resourceRequestService.getResourceRequestFiles(this.resourceRequest.id, true),
						)),
					);
					this.listEmitters.files.emit(this.lists.files);
				}
				this.onSkillsLoad.emit({
					logicalOperator: patchedResourceRequest.skillOperator,
					skillDbRows: patchedResourceRequest.internalSkillset,
				} as RedesignSkillDbFilterData);
				this.listsEmitTimeOut();
			});
		} else {
			this.addMode = true;
			this.permissions.hasGeneralWritePermissions = true;

			this.resourceRequest = {} as ResourceRequest;
			// Presets
			this.formGroups.f2FrameData.controls.requestedFrom.setValue(this.currentUser.employee);
			this.formGroups.f3InternalHistory.controls.responsibleDE.setValue(this.currentUser.employee);
			//this.formGroups.f3InternalHistory.controls.businessUnits.setValue([this.currentUser.employee?.businessUnit]);
			this.formGroups.f3InternalHistory.controls.responsibleBusinessUnit.setValue(
				this.currentUser.employee?.businessUnit,
			);
			this.formGroups.f2FrameData.controls.requestingUnit.setValue(this.currentUser.employee?.businessUnit);
			this.formGroups.f0Header.controls.commitmentStart.setValue(moment(Date.now()).toISOString().substring(0, 10));
			this.formGroups.f3InternalHistory.controls.requestReceipt.setValue(
				moment(Date.now()).toISOString().substring(0, 10),
			);
			this.formGroups.f0Header.controls.requestStatus.setValue("AT_WORK");
			this.formGroups.f0Header.controls.probability.setValue("MISSING_VALUE");
			this.formGroups.f0Header.controls.requestType.setValue("STAFF");
		}
	}

	private async getResourceRequest() {
		if (this._activatedRoute.snapshot.params["instance"]) {
			this.instanceNameOfRR = this._activatedRoute.snapshot.params["instance"];
			return await firstValueFrom(
				this._resourceRequestService.getGlobalById(
					this.resourceRequestId || this._activatedRoute.snapshot.params["resourceRequestId"],
					this._activatedRoute.snapshot.params["instance"],
				),
			);
		} else {
			this.instanceNameOfRR = await firstValueFrom(this._globalService.getLocalInstanceName());

			return await firstValueFrom(
				this._resourceRequestService.getById(
					this.resourceRequestId || this._activatedRoute.snapshot.params["resourceRequestId"],
				),
			);
		}
	}

	async submit() {
		if (this.saving) {
			return;
		}
		if (
			this.formGroups.f0Header.invalid ||
			this.formGroups.f1CustomerData.invalid ||
			this.formGroups.f2FrameData.invalid ||
			this.formGroups.f3InternalHistory.invalid
		) {
			this.formGroups.f0Header.markAllAsTouched();
			this.formGroups.f1CustomerData.markAllAsTouched();
			this.formGroups.f2FrameData.markAllAsTouched();
			this.formGroups.f3InternalHistory.markAllAsTouched();
			if (
				!this.formGroups.f0Header.controls.statusComment.invalid &&
				!this.formGroups.f0Header.controls.resubmissionDate.invalid
			) {
				this._messageService.add(
					this.translate.instant("mep.components.employee-list.errors.not-filled"),
					AlertEnum.DANGER,
				);
			}
			return;
		}

		this.saving = true;
		this.loading = true;
		this.isFormEditable = false;

		const previousDispoFlag = this.resourceRequest?.dispoFlag;

		//#region patching data
		let rawFormData = {
			...this.formGroups.f0Header.getRawValue(),
			...this.formGroups.f1CustomerData.getRawValue(),
			...this.formGroups.f2FrameData.getRawValue(),
			...this.formGroups.f3InternalHistory.getRawValue(),
		};

		if ((this.addMode && rawFormData.dispoFlag) || (!this.addMode && rawFormData.dispoFlag !== previousDispoFlag)) {
			rawFormData["dispoFlagLastChangedAt"] = moment().format("YYYY-MM-DD");
		}

		const transformedOffers = this.lists.offers.map((offer) => {
			const employee: any = {
				id: offer.id,
				firstName: offer.firstName,
				lastName: offer.lastName,
				email: offer.email,
			};

			return {
				employee: employee,
				offeredStatus: offer.offeredStatus,
				offeredEmployeeBu: offer.offeredEmployeeBu,
				createdByUser: offer.createdByUser,
				enableDownload: offer.enableDownload ?? false,
			};
		});

		const transformedInterestedResponsible = this.lists.interestedResponsible.map((resp) => {
			const employee: any = {
				id: resp.id,
				firstName: resp.firstName,
				businessUnit: resp.offeredEmployeeBu,
			};

			return employee;
		});

		let allSkills = await this._employeeService.getAllSkillsBySearchTerm("");

		let resourceRequest = {
			...this.resourceRequest,

			...rawFormData,

			compensation: rawFormData.compensation?.toString().replace(",", "."),
			requestedBy: employeeDisplayFn(this.formGroups.f2FrameData.controls.requestedBy.value),
			requestingUnit: this.formGroups.f2FrameData.controls.requestingUnit.value,
			requestedFrom: this.formGroups.f2FrameData.controls.requestedFrom.value,
			client: this.formGroups.f1CustomerData.controls.client.value,
			desiredCandidate: employeeDisplayFn(this.formGroups.f1CustomerData.controls.desiredCandidate.value),
			currentProject: rawFormData.currentProject?.toString().trim().length > 0 ? rawFormData.currentProject : null,

			internalSkillset: this.mapSkills(rawFormData.internalSkillset, allSkills),
			// if the user adds a skill that is not in the database, it will be ignored
			files: this.lists.files,
			offered: transformedOffers,
			staffingComments: this.lists.staffingComments,
			interestedStaffingComments: this.lists.interestedStaffingComments,
			staffingTag: this.lists.staffingTags?.join(", ") || "",
			interestedResponsible: transformedInterestedResponsible,
			businessUnits: rawFormData.businessUnits || [],
			responsibleBusinessUnit: rawFormData.responsibleBusinessUnit || [],
			divisions: rawFormData.divisions || "",
			offeredChangedStatus: this.offeredStatusChange,
			responsibleDE:
				this.formGroups.f3InternalHistory.controls.responsibleDE.value === "-"
					? this.resourceRequest.responsibleDE
					: this.formGroups.f3InternalHistory.controls.responsibleDE.value,
		} as ResourceRequest;

		this.fillInMissingEnumValues(rawFormData);

		if (this.addMode && this.isMultiResourceRequestSafeMode) {
			resourceRequest.id = null;
			delete resourceRequest.createdAt;
			delete resourceRequest.createdBy;
		}

		//#endregion

		this.offeredStatusChange = null;

		await this.extractSkillsIfNeeded(resourceRequest, allSkills);

		// map countryOfStaffing
		resourceRequest.staffingLocation = resourceRequest.countryOfStaffing || null;

		// Fire-and-forget: start save request but don't block UI waiting for response
		const request$ = this.addMode
			? this._resourceRequestService.createResourceRequest(
					resourceRequest,
					resourceRequest.requestType === "TASK",
					this.lang,
				)
			: this._resourceRequestService.updateResourceRequest(
					resourceRequest,
					resourceRequest.requestType === "TASK",
					this.lang,
				);

		// Immediately mark saved in UI; background tasks (including email) run on server
		this._messageService.add(
			this.formGroups.f0Header.controls.requestTitle.value + this._lang("save-success"),
			AlertEnum.SUCCESS,
		);
		this.saving = false;
		this.loading = false;
		this.isFormEditable = true;

		// subscribe to handle server response or error and update UI/data as needed
		request$.pipe(take(1)).subscribe({
			next: async (result: ResourceRequestUpdateDTO) => {
				try {
					// update local resourceRequest with server-provided DTO
					this.resourceRequest = result.resourceRequestDTO;
					this.resourceRequestCreated.emit(true);

					// show any notification warnings returned by server
					result.businessUnitNotificationErrors
						.map((error) => this.translate.instant(error.key, error.arguments))
						.forEach((error) => this._messageService.add(error, AlertEnum.WARNING));

					result.divisionNotificationErrors
						.map((error) => this.translate.instant(error.key, error.arguments))
						.forEach((error) => this._messageService.add(error, AlertEnum.WARNING));

					// refresh files list if there were uploaded files
					if (
						this.lists.files.filter((asset) => asset.id == null).length > 0 &&
						document.getElementById("assetPicker")
					) {
						this.lists.files.length = 0;
						this.lists.files.push(
							...(await firstValueFrom(
								this._resourceRequestService.getResourceRequestFiles(this.resourceRequest.id, true),
							)),
						);
						this.listEmitters.files.emit(this.lists.files);
					}

					if (!this.addMode && this.resourceRequest.interestedStaffingComments) {
						this.lists.interestedStaffingComments.length = 0;
						this.lists.interestedStaffingComments.push(...this.resourceRequest.interestedStaffingComments);
						this.listEmitters.interestedStaffingComments.emit(this.lists.interestedStaffingComments);
					} else {
						this.lists.staffingComments.length = 0;
						if (this.resourceRequest.staffingComments) {
							this.lists.staffingComments.push(...this.resourceRequest.staffingComments);
							this.listEmitters.staffingComments.emit(this.lists.staffingComments);
						}
					}
					this.listsEmitTimeOut();

					// navigate only after server has returned id for new resourceRequests
					if (this.addMode) {
						if (!this.isMultiResourceRequestSafeMode) {
							this.canExit = true;
							this._importRefreshService.refreshScreens(true);
							await this.breadCrumbsNavigationService.clearListFromStorage("resourceRequest");
							await this._router.navigate(["/resource-request-list/" + this.resourceRequest.id]);
						} else {
							this.formGroups.f0Header.patchValue({requestTitle: ""});
						}
					} else {
						this.formGroups.f0Header.markAsPristine();
						this.formGroups.f1CustomerData.markAsPristine();
						this.formGroups.f2FrameData.markAsPristine();
						this.formGroups.f3InternalHistory.markAsPristine();
					}
				} catch (e) {
					// On error while processing success, just log and show message
					this._messageService.add(
						this.translate.instant("mep.components.employee-list.errors.unknown"),
						AlertEnum.DANGER,
					);
				}
			},
			error: (err) => {
				// if the request fails, re-enable editing and show error
				this.saving = false;
				this.loading = false;
				this.isFormEditable = true;
				this._messageService.add(
					this.translate.instant("mep.components.employee-list.errors.save-failed"),
					AlertEnum.DANGER,
				);
				console.error(err);
			},
		});
	}

	async extractSkillsIfNeeded(resourceRequestToSave: ResourceRequest, allSkills: Skill[]) {
		try {
			if (
				this.addMode &&
				this.formGroups.f1CustomerData.controls.skillDescriptionOfCustomer.value !== "" &&
				(!resourceRequestToSave.internalSkillset || resourceRequestToSave.internalSkillset.length === 0)
			) {
				let skills: SkillDbEntry[] = await this.openSkillExtractionDialog();
				if (skills) {
					resourceRequestToSave.internalSkillset = this.mapSkills(skills, allSkills);
				}
			}
		} catch (e) {
			return;
		}
	}

	private mapSkills(skills: SkillDbEntry[], allSkills: Skill[]): SkillWithMinimumLevel[] {
		const normalizeSkillName = (name: string): string[] => {
			return name
				.split(";")
				.map((variant) =>
					variant
						.replace(/\s*\([^)]*\)/g, "")
						.trim()
						.toLowerCase(),
				)
				.concat(name.split(";").map((variant) => variant.trim().toLowerCase()));
		};

		return skills
			.map(
				(skill) =>
					({
						minimumLevel: skill.level,
						skill: allSkills.find((s) => {
							const searchVariants = normalizeSkillName(
								this.lang === LanguageEnum.DE ? skill.skillNameDe : skill.skillNameEn,
							);
							const skillVariants = normalizeSkillName(this.lang === LanguageEnum.DE ? s.skillNameDe : s.skillNameEn);
							return searchVariants.some((search) => skillVariants.includes(search));
						}),
					}) as SkillWithMinimumLevel,
			)
			.filter((skill) => skill.skill != null);
	}

	async openSkillExtractionDialog(): Promise<SkillDbEntry[]> {
		if (localStorage.getItem("noUnnecessaryPopups") === "true") {
			return;
		}
		const skills = await this.getSkillsFromProfileMep();
		if (skills.length) {
			const dialogRef = this._dialog.open(ProfileMapExtractionPopupComponent, {
				data: {
					skills,
				},
				maxHeight: "90vh",
				maxWidth: "50vw",
			});

			const value = await dialogRef.afterClosed().toPromise();
			if (value) {
				return skills;
			}
		}
	}

	checkIfUserHasInterestedBu(withoutResponsibleBu: boolean = false): boolean {
		if (withoutResponsibleBu) {
			return this.resourceRequest.businessUnits
				.filter((bu) => bu !== this.resourceRequest.responsibleBusinessUnit)
				.some((bu) => this.resourceRequest.businessUnits.includes(bu));
		} else {
			return this.businessUnitsOfUser.some((bu) => this.resourceRequest.businessUnits.includes(bu));
		}
	}

	listsEmitTimeOut() {
		setTimeout(() => {
			this.listEmitters.staffingComments.emit(this.lists.staffingComments);
			this.listEmitters.interestedStaffingComments.emit(this.lists.interestedStaffingComments);
			this.listEmitters.offers.emit(this.lists.offers);
			this.refreshOfferFileAvailability();
			this.listEmitters.interestedResponsible.emit(this.lists.interestedResponsible);
		}, 0);
	}

	fillInMissingEnumValues(rawFormData) {
		const attributes = ["currency", "travelMode", "probability"];
		for (const attribute of attributes) {
			if (!rawFormData[attribute]) {
				rawFormData[attribute] = Config.services.missingValueBackend;
			}
		}
	}

	/**
	 * loads autocomplete lists and generates filtered lists for formControl.valueChanges
	 */
	generateAutocompleteFilterLists<T>(autocompleteOccurrence: AutocompleteType<T>, valueChanges: Observable<string>) {
		autocompleteOccurrence.filtered = valueChanges.pipe(
			startWith(""),
			switchMap(async (input) => {
				// adds a few items that start with the input to the list
				// and more items that contain the input
				let original = await autocompleteOccurrence.original;

				let list = original
					.filter((value) =>
						startsWith(
							(autocompleteOccurrence.display ? autocompleteOccurrence.display(value) : value).toString().toLowerCase(),
							input?.toString().toLowerCase(),
						),
					)
					.slice(0, this.listMaxLength / 10);

				list.push(
					...original
						.filter(
							(value) =>
								includes(
									(autocompleteOccurrence.display ? autocompleteOccurrence.display(value) : value)
										.toString()
										.toLowerCase(),
									input?.toString().toLowerCase(),
								) && !list.includes(value),
						)
						.slice(0, this.listMaxLength),
				);
				return list;
			}),
		);
	}

	// endregion
	// region list Picker helper
	mapAssets = (originalList: ResourceRequestFile[]) =>
		originalList.map((asset) => ({
			firstColumn: asset.createdBy,
			firstColumnDate: asset.createdAt,
			secondColumn: asset.name,
			secondColumnLink: asset.id
				? () => {
						this._fileDownloadService
							.downloadFile("/mep/api/resource-request/add/downloadFile/" + asset.id, asset.name)
							.subscribe();
					}
				: null,
			thirdColumn: asset.comment,
			toggle: asset.visibleOverall,
			original: asset,
		}));

	onAssetDelete(asset: ResourceRequestFile) {
		this.openConfirmationDialogForDelete("mep.components.general.notification.delete-staffing-request").subscribe(
			(confirmed: boolean) => {
				if (confirmed) {
					this.lists.files.splice(this.lists.files.indexOf(asset), 1);
					this.listEmitters.files.emit(this.lists.files);

					if (asset.id) {
						this.loading = true;
						firstValueFrom(
							this._resourceRequestService.deleteResourceRequestFile(
								asset.id,
								this.isTypeTask,
								this.resourceRequest.id,
							),
						).then(() => {
							this._messageService.add(
								this.translate.instant("mep.components.toasts.was-deleted", {entity: asset.name}),
								AlertEnum.SUCCESS,
							);
							this.loading = false;
						});
					}
				}
			},
		);
	}

	onAssetAdd() {
		let dialogRef = this._dialog.open(AssetsUploadComponent);
		dialogRef.afterClosed().subscribe((result) => {
			if (result) {
				this.lists.files.push(result);
				this.formGroups.f1CustomerData.controls.files.setValue(clone(this.lists.files));
				this.listEmitters.files.emit(this.lists.files);
			}
		});
	}

	mapOffers = (originalList: EmployeeFullNameEmailStatus[]) => {
		return originalList.map((offer) => ({
			firstColumn: `${offer.lastName ? offer.lastName + "," : ""} ${offer.firstName}`,
			firstColumnDate: null,
			secondColumn: MarketUnit.MarketUnit[offer.offeredEmployeeBu],
			thirdColumn: null,
			profileViewId: this.offeredEmployeeIdsWithFiles.has(offer.id) ? offer.id : undefined,
			status: offer.offeredStatus,
			original: offer,
		}));
	};

	private refreshOfferFileAvailability() {
		const requestId = ++this.offerFileAvailabilityRequestId;
		this.offeredEmployeeIdsWithFiles.clear();
		const employeeIds = Array.from(
			new Set(this.lists.offers.map((offer) => offer.id).filter((id): id is number => id != null)),
		);

		if (employeeIds.length === 0) {
			return;
		}

		this._employeeFileService.checkEmployeesHaveFiles(employeeIds, true).subscribe((result) => {
			if (requestId !== this.offerFileAvailabilityRequestId) {
				return;
			}

			result.forEach((hasFiles, employeeId) => {
				if (hasFiles) {
					this.offeredEmployeeIdsWithFiles.add(employeeId);
				}
			});
			this.listEmitters.offers.emit(this.lists.offers);
		});
	}

	mapInterestedResponsible = (originalList: EmployeeFullNameEmailStatus[]) => {
		return originalList.map((interestedResponsible) => ({
			firstColumn: `${interestedResponsible.lastName ? interestedResponsible.lastName + "," : ""} ${interestedResponsible.firstName}`,
			firstColumnDate: null,
			secondColumn: null,
			thirdColumn: null,
			original: interestedResponsible,
		}));
	};

	onAssetsToggleChange(asset) {
		let assetToUpdate = this.lists.files.find((file) => file === asset.original);
		assetToUpdate.visibleOverall = asset.toggle;
		this.formGroups.f1CustomerData.controls.files.setValue(clone(this.lists.files));
		this.listEmitters.files.emit(this.lists.files);
	}

	onOfferedStatusChange(offered) {
		let offerToUpdate = this.lists.offers.find((offer) => offer === offered.original);
		if (offerToUpdate) {
			offerToUpdate.offeredStatus = offered.properties;
			this.offeredStatusChange = new OfferedChangedStatus(
				offerToUpdate.lastName ? `${offerToUpdate.firstName} ${offerToUpdate.lastName}` : offerToUpdate.firstName,
				offerToUpdate.offeredStatus,
				offerToUpdate.offeredEmployeeBu,
			);
			this.formGroups.f3InternalHistory.controls.offered.setValue(clone(this.lists.offers));
			this.listEmitters.offers.emit(this.lists.offers);
		}
	}

	filterColumnByValue(column: string, value: any[]) {
		// Choose on of the columns: ['firstColumn', 'secondColumn', 'thirdColumn', 'status'] and give the value you want to filter
		let filter = {};
		filter[column] = value;

		return filter;
	}

	filterCommentListByBu(commentList: Observable<StaffingComment[]>, bu: string): Observable<StaffingComment[]> {
		return commentList.pipe(
			map((originalList) => {
				return originalList.filter((comment) => comment.businessUnit === bu);
			}),
		);
	}

	sortOfferListByStatusAndLastName(
		offerList: Observable<EmployeeFullNameEmailStatus[]>,
	): Observable<EmployeeFullNameEmailStatus[]> {
		return offerList.pipe(
			map((originalList) => {
				const statusOrder: OfferedEmployeeStatus[] = [
					OfferedEmployeeStatus.PROFILE_ACCEPTED_BY_CUSTOMER,
					OfferedEmployeeStatus.PROFILE_IDEA,
					OfferedEmployeeStatus.PROFILE_NOT_OFFERED,
					OfferedEmployeeStatus.PROFILE_DECLINED,
				];

				const sortedList = originalList.sort((a, b) => {
					if (
						a.offeredStatus === OfferedEmployeeStatus.PROFILE_SHORTLIST &&
						b.offeredStatus !== OfferedEmployeeStatus.PROFILE_SHORTLIST
					) {
						return -1;
					} else if (
						a.offeredStatus !== OfferedEmployeeStatus.PROFILE_SHORTLIST &&
						b.offeredStatus === OfferedEmployeeStatus.PROFILE_SHORTLIST
					) {
						return 1;
					} else {
						if (
							a.offeredStatus !== OfferedEmployeeStatus.PROFILE_SHORTLIST &&
							b.offeredStatus !== OfferedEmployeeStatus.PROFILE_SHORTLIST
						) {
							return statusOrder.indexOf(a.offeredStatus) - statusOrder.indexOf(b.offeredStatus);
						}

						const lastNameA = a.lastName || "";
						const lastNameB = b.lastName || "";
						return lastNameA.localeCompare(lastNameB);
					}
				});

				return sortedList;
			}),
		);
	}

	filterInterestedResponsibleListByBu(
		responsibleList: Observable<EmployeeFullNameEmailStatus[]>,
		bu: string,
	): Observable<EmployeeFullNameEmailStatus[]> {
		return responsibleList.pipe(
			map((originalList) => {
				return originalList.filter((responsible) => responsible.offeredEmployeeBu === bu);
			}),
		);
	}

	openConfirmationDialogForDelete(message: string): Observable<boolean> {
		const dialogRef = this._dialog.open(ConfirmationDialogComponent, {
			disableClose: false,
			data: {
				messageKey: message,
				params: {},
			},
		});
		return dialogRef.afterClosed().pipe(map((value) => !!value));
	}

	onOfferDelete(offer: EmployeeFullNameEmailStatus) {
		this.openConfirmationDialogForDelete("mep.components.general.notification.delete-offered-employee").subscribe(
			(confirmed: boolean) => {
				if (confirmed) {
					this.lists.staffingComments.push({
						createdAt: moment(new Date()).toISOString(),
						createdBy: this.currentUser.username,
						comment:
							"Angebotener Mitarbeiter " +
							(offer.lastName ? offer.firstName + ", " + offer.lastName : offer.firstName) +
							" wurde entfernt",
						businessUnit: null,
					});
					this.listEmitters.staffingComments.emit(this.lists.staffingComments);
					this.lists.offers.splice(this.lists.offers.indexOf(offer), 1);
					this.formGroups.f3InternalHistory.controls.offered.setValue(clone(this.lists.offers));
					this.listEmitters.offers.emit(this.lists.offers);
				}
			},
		);
	}

	onOfferAdd(bu: string, canDelete = true) {
		const dialog = this._dialog.open(OfferedEmployeesComponent, {
			data: {
				employees: this.lists.offers,
				nameSavePossible: true,
				businessUnitToFilter: bu,
				userName: this.currentUser.username,
				allowedToDelete: canDelete,
				fromProjectAdd: false,
				showProfileDownloadToggle: true,
			},
		});
		dialog.afterClosed().subscribe((data) => {
			if (data !== undefined && data !== null && Array.isArray(data)) {
				if (data.length > 0) {
					let offeredBeforeDelete = clone(this.lists.offers);
					const offerToUpdate = data[data.length - 1];
					if (offerToUpdate) {
						this.offeredStatusChange = new OfferedChangedStatus(
							offerToUpdate.lastName ? `${offerToUpdate.firstName} ${offerToUpdate.lastName}` : offerToUpdate.firstName,
							null,
							offerToUpdate.offeredEmployeeBu,
						);
					}
					offeredBeforeDelete.forEach((offered) => {
						if (!data.find((offer) => offer.id === offered.id)) {
							this.lists.staffingComments.push({
								createdAt: moment(new Date()).toISOString(),
								createdBy: this.currentUser.username,
								comment:
									"Angebotener Mitarbeiter " +
									(offered.lastName ? offered.firstName + ", " + offered.lastName : offered.firstName) +
									" wurde entfernt",
								businessUnit: null,
							});
						}
					});

					this.lists.offers.splice(0, this.lists.offers.length);
					this.lists.offers.push(...data);
					this.formGroups.f3InternalHistory.controls.offered.setValue(clone(this.lists.offers));
					this.listEmitters.offers.emit(this.lists.offers);
				} else {
					this.lists.offers = [];
					this.formGroups.f3InternalHistory.controls.offered.setValue([]);
					this.listEmitters.offers.emit([]);
				}
				this.refreshOfferFileAvailability();
			}
			// If data is undefined, null, or not an array, do nothing - keep existing list
		});
	}

	getTransferToProjectTooltip = (): string => {
		const project = this.formGroups.f1CustomerData.controls.currentProject.value;
		if (project) {
			return this._lang("transfer-to-project-tooltip", {projectName: project.projectName});
		}
		return this._lang("transfer-to-project-button");
	};

	onTransferToProject(offeredEmployee: EmployeeFullNameEmailStatus) {
		if (!offeredEmployee.id) {
			this._messageService.add(
				this._translate.instant("mep.components.toasts.cannot-assign-manual-candidate"),
				AlertEnum.WARNING,
			);
			return;
		}

		const project = this.formGroups.f1CustomerData.controls.currentProject.value;
		if (!project) {
			this._messageService.add(this._lang("no-project-assigned"), AlertEnum.WARNING);
			return;
		}

		if (!project._links) {
			project._links = {
				self: {
					href: Config.services.projects.baseUrl + project.id,
				},
			};
		}

		const formData = {
			effectiveFrom: this.formGroups.f0Header.controls.commitmentStart.value,
			effectiveUntil: this.formGroups.f0Header.controls.commitmentEnd.value,
			capacity: this.formGroups.f2FrameData.controls.scope.value,
			role: this.formGroups.f1CustomerData.controls.role.value || null,
			annotation: null,
			workPackage: null,
			workItem: null,
			subTeam: null,
			extRate: this.formGroups.f2FrameData.controls.compensation.value,
			extRateCurrency: this.formGroups.f2FrameData.controls.currency.value,
			transferRate: null,
			transferRateCurrency: null,
		};

		const assignData: AssignData = {
			project: project,
			disableProjects: true,
			employee: {
				id: offeredEmployee.id,
				firstName: offeredEmployee.firstName,
				lastName: offeredEmployee.lastName,
				personnelNumber: offeredEmployee.personnelNumber,
			} as Employee,
			formData: formData,
		};

		const dialog = this._dialog.open(AssignEmployeeDialogComponent, {
			data: assignData,
			width: "90%",
			height: "90%",
		});

		dialog.afterClosed().subscribe((result) => {
			if (result) {
				this._messageService.add(this._lang("employee-assigned-to-project"), AlertEnum.SUCCESS);
			}
		});
	}

	openEmployeeFilesViewDialog(employeeId: number) {
		if (employeeId !== null) {
			const offeredEmployee = this.lists.offers.find((offer) => offer.id === employeeId);

			this._dialog.open(FilesViewDialogComponent, {
				data: {
					employeeId,
					enableDownload: offeredEmployee?.enableDownload === true,
					offeredEmployee: offeredEmployee
						? {
								id: offeredEmployee.id,
								firstName: offeredEmployee.firstName,
								lastName: offeredEmployee.lastName,
								offeredEmployeeBu: offeredEmployee.offeredEmployeeBu,
								declarationOfConsentEntities: offeredEmployee.declarationOfConsentEntities,
								declarationOfConsentCustomers: offeredEmployee.declarationOfConsentCustomers,
							}
						: undefined,
					resourceRequestId: this.resourceRequest?.id,
					resourceRequestTitle: this.resourceRequest?.requestTitle,
					staffingProfileDownloadMode: !!offeredEmployee,
				},
				disableClose: true,
			});
		}
	}

	showProfileViewButton() {
		const responsibleBusinessUnit =
			this.formGroups.f3InternalHistory.controls.responsibleBusinessUnit.value ||
			this.resourceRequest?.responsibleBusinessUnit;
		const loginUserBusinessUnit = this.currentUser?.employee?.businessUnit;

		return (
			this._authService.hasAnyRole(this.profileViewButtonRoles) &&
			!!responsibleBusinessUnit &&
			!!loginUserBusinessUnit &&
			responsibleBusinessUnit === loginUserBusinessUnit
		);
	}

	onInterestedResponsibleDelete(responsible: EmployeeFullNameEmailStatus) {
		this.openConfirmationDialogForDelete("mep.components.general.notification.delete-interested-responsible").subscribe(
			(confirmed: boolean) => {
				if (confirmed) {
					this.lists.interestedResponsible.splice(this.lists.interestedResponsible.indexOf(responsible), 1);
					this.formGroups.f3InternalHistory.controls.interestedResponsible.setValue(
						clone(this.lists.interestedResponsible),
					);
					this.listEmitters.interestedResponsible.emit(this.lists.interestedResponsible);
				}
			},
		);
	}

	onInterestedResponsibleAdd(bu: string, canDelete = true) {
		const nameSavePossible = !this.buAllowlist.includes(bu);
		//Using the same component as for offered employees because it fits all requirements
		const dialog = this._dialog.open(OfferedEmployeesComponent, {
			data: {
				employees: this.lists.interestedResponsible,
				nameSavePossible: nameSavePossible,
				businessUnitToFilter: bu,
				allowedToDelete: canDelete,
			},
		});
		dialog.afterClosed().subscribe((data) => {
			if (data) {
				this.lists.interestedResponsible.splice(0, this.lists.interestedResponsible.length);
				this.lists.interestedResponsible.push(...data);
				this.formGroups.f3InternalHistory.controls.interestedResponsible.setValue(
					clone(this.lists.interestedResponsible),
				);
				this.listEmitters.interestedResponsible.emit(this.lists.interestedResponsible);
			}
		});
	}

	offerFindProfilePicture = (offer: EmployeeFullNameEmailStatus, api: string) => `${api}${offer.email}`;

	mapStaffingComments = (originalList: StaffingComment[]) =>
		originalList.map((comment) => ({
			firstColumn: comment.createdBy as string,
			firstColumnDate: comment.createdAt,
			secondColumn: comment.comment as string,
			thirdColumn: null,
			original: comment,
			status: null,
		}));

	onStaffingCommentsDelete(staffingComment: StaffingComment) {
		this.openConfirmationDialogForDelete("mep.components.general.notification.delete-staffing-comment").subscribe(
			(confirmed: boolean) => {
				if (confirmed) {
					this.lists.staffingComments.splice(this.lists.staffingComments.indexOf(staffingComment), 1);
					this.formGroups.f3InternalHistory.controls.staffingComments.setValue(clone(this.lists.staffingComments));
					this.listEmitters.staffingComments.emit(this.lists.staffingComments);
				}
			},
		);
	}

	onStaffingCommentsAdd() {
		const dialogRef = this._dialog.open(StaffingCommentDialogComponent, {
			width: "20%",
			data: this.lists.staffingComments,
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result) {
				this.lists.staffingComments.push({
					createdAt: moment(new Date()).toISOString(),
					createdBy: this.currentUser.username,
					comment: result.data.value,
					businessUnit: result.data.businessUnit,
				});
				this.formGroups.f3InternalHistory.controls.staffingComments.setValue(clone(this.lists.staffingComments));
				this.listEmitters.staffingComments.emit(this.lists.staffingComments);
			}
		});
	}

	onInterestedStaffingCommentsDelete(interestedStaffingComment: StaffingComment) {
		this.openConfirmationDialogForDelete("mep.components.general.notification.delete-staffing-comment").subscribe(
			(confirmed: boolean) => {
				if (confirmed) {
					this.lists.interestedStaffingComments.splice(
						this.lists.interestedStaffingComments.indexOf(interestedStaffingComment),
						1,
					);
					this.formGroups.f3InternalHistory.controls.interestedStaffingComments.setValue(
						clone(this.lists.interestedStaffingComments),
					);
					this.listEmitters.interestedStaffingComments.emit(this.lists.interestedStaffingComments);
				}
			},
		);
	}

	onInterestedStaffingCommentAdd(bu: string) {
		const dialogRef = this._dialog.open(StaffingCommentDialogComponent, {
			width: "20%",
			data: this.lists.interestedStaffingComments,
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result) {
				this.lists.interestedStaffingComments.push({
					createdAt: moment(new Date()).toISOString(),
					createdBy: this.currentUser.username,
					comment: result.data.value,
					businessUnit: bu,
				});
				this.formGroups.f3InternalHistory.controls.interestedStaffingComments.setValue(
					clone(this.lists.interestedStaffingComments),
				);
				this.listEmitters.interestedStaffingComments.emit(this.lists.interestedStaffingComments);
			}
		});
	}

	canReadConfidentialField() {
		return !this.permissions.isForeignBUsRR && this.permissions.hasReadOnConfidentialFields;
	}

	isRendered(): boolean {
		return this.rendered;
	}

	canDeactivate(): boolean {
		return (
			this.canExit ||
			(this.formGroups.f0Header.pristine &&
				this.formGroups.f1CustomerData.pristine &&
				this.formGroups.f2FrameData.pristine &&
				this.formGroups.f3InternalHistory.pristine)
		);
	}

	onUpdateSkills($event: {operator: string; skillList: SkillDbEntry[]}) {
		this.formGroups.f1CustomerData.controls.internalSkillset.setValue($event.skillList);
		this.formGroups.f1CustomerData.controls.skillOperator.setValue($event.operator);

		this.formGroups.f1CustomerData.controls.internalSkillset.markAsDirty();
		this.formGroups.f1CustomerData.controls.skillOperator.markAsDirty();
	}

	addStaffingTag($event: string, staffingTagInput: HTMLInputElement) {
		if (!this.optionSelected) {
			if ($event.trim().length === 0) {
				return;
			}

			if (!this.lists.staffingTags.includes($event)) {
				this.lists.staffingTags.push($event);
			}

			staffingTagInput.value = "";
			this.formGroups.f3InternalHistory.controls.staffingTag.setValue("");
			if (!this.addMode) {
				this.submit().then();
			}
		}
		this.optionSelected = false;
	}

	selected($event: string, staffingTagInput: HTMLInputElement) {
		this.optionSelected = true;
		this.lists.staffingTags.push($event);
		staffingTagInput.value = "";
		this.formGroups.f3InternalHistory.controls.staffingTag.setValue("");
		if (!this.addMode) {
			this.submit().then();
		}
	}

	deleteStaffingTag($event: string) {
		this.lists.staffingTags.splice(this.lists.staffingTags.indexOf($event), 1);
		this.formGroups.f3InternalHistory.controls.staffingTag.markAsDirty();
		if (!this.addMode) {
			this.submit().then();
		}
	}

	async extractSkillsFromDescription(alreadyDeclaredSkills: SkillDbEntry[]) {
		this.loading = true;
		let skills: SkillDbEntry[] = [];

		if (alreadyDeclaredSkills && alreadyDeclaredSkills.length > 0) {
			skills = alreadyDeclaredSkills;
		} else if (this.formGroups.f1CustomerData.controls.skillDescriptionOfCustomer.value.length > 0) {
			let response = await firstValueFrom(
				this._resourceRequestService.getProfileMapSkills(
					this.formGroups.f1CustomerData.controls.skillDescriptionOfCustomer.value,
					this.lang,
				),
			);
			for (const item of response) {
				if (this.lang === LanguageEnum.DE) {
					skills.push({skillNameDe: item, level: 1} as SkillDbEntry);
				} else {
					skills.push({skillNameEn: item, level: 1} as SkillDbEntry);
				}
			}
		}

		if (skills.length > 0) {
			this.formGroups.f1CustomerData.controls.internalSkillset.setValue([
				...skills,
				...this.formGroups.f1CustomerData.controls.internalSkillset.value.filter(
					(preexistingSkill) =>
						!skills.find(
							(newSkill) =>
								preexistingSkill.skillNameDe === newSkill.skillNameDe ||
								preexistingSkill.skillNameEn === newSkill.skillNameEn ||
								preexistingSkill.skillNameAlt === newSkill.skillNameAlt,
						),
				),
			]);
			this.formGroups.f1CustomerData.controls.internalSkillset.markAsDirty();
			this.onSkillsLoad.emit({
				logicalOperator: this.formGroups.f1CustomerData.controls.skillOperator.value,
				skillDbRows: this.formGroups.f1CustomerData.controls.internalSkillset.value,
			} as RedesignSkillDbFilterData);
		}
		this.loading = false;
	}

	fillFormFields(resourceRequest: ResourceRequest) {
		if (resourceRequest) {
			const formControls = this.formGroups.f0Header.controls;
			Object.keys(formControls).forEach((key) => {
				if (resourceRequest[key] !== undefined && resourceRequest[key] !== null) {
					formControls[key].setValue(resourceRequest[key]);
				}
			});

			const formControlsCustomerData = this.formGroups.f1CustomerData.controls;
			Object.keys(formControlsCustomerData).forEach((key) => {
				if (resourceRequest[key] !== undefined && resourceRequest[key] !== null) {
					formControlsCustomerData[key].setValue(resourceRequest[key]);
				}
			});

			const formControlsFrameData = this.formGroups.f2FrameData.controls;
			Object.keys(formControlsFrameData).forEach((key) => {
				if (resourceRequest[key] !== undefined && resourceRequest[key] !== null) {
					formControlsFrameData[key].setValue(resourceRequest[key]);
				}
			});

			const formControlsInternalHistory = this.formGroups.f3InternalHistory.controls;
			Object.keys(formControlsInternalHistory).forEach((key) => {
				if (resourceRequest[key] !== undefined && resourceRequest[key] !== null) {
					formControlsInternalHistory[key].setValue(resourceRequest[key]);
				}
			});
		}
	}

	async getSkillsFromProfileMep(): Promise<SkillDbEntry[]> {
		let response = await firstValueFrom(
			this._resourceRequestService.getMepSkills(
				this.formGroups.f1CustomerData.controls.skillDescriptionOfCustomer.value,
				this.lang,
			),
		);
		const skills: SkillDbEntry[] = [];
		for (const item of response) {
			switch (this.lang) {
				case LanguageEnum.DE: {
					skills.push({skillNameDe: item, level: 1} as SkillDbEntry);
					break;
				}
				case LanguageEnum.EN: {
					skills.push({skillNameEn: item, level: 1} as SkillDbEntry);
					break;
				}
				default: {
					skills.push({skillNameAlt: item, level: 1} as SkillDbEntry);
					break;
				}
			}
		}
		return skills;
	}

	openDialogForUploadToMephisto() {
		const dialogRef = this._dialog.open(MephistoUploadDialogComponent);

		dialogRef.afterClosed().subscribe(async (mephistoPollingResponseDTO) => {
			if (mephistoPollingResponseDTO?.resourceRequestDTO) {
				this._messageService.add(
					this._translate.instant("mep.components.add-resource-request.mephisto-autofill-successful"),
					AlertEnum.SUCCESS,
				);
				this.fillFormFields(mephistoPollingResponseDTO.resourceRequestDTO);
			}
		});
	}

	async extractMEPSkillsFromDescription() {
		this.loading = true;
		if (this.formGroups.f1CustomerData.controls.skillDescriptionOfCustomer.value.length > 0) {
			let response = await firstValueFrom(
				this._resourceRequestService.getMepSkills(
					this.formGroups.f1CustomerData.controls.skillDescriptionOfCustomer.value,
					this.lang,
				),
			);
			const skills: SkillDbEntry[] = [];
			for (const item of response) {
				switch (this.lang) {
					case LanguageEnum.DE: {
						skills.push({skillNameDe: item, level: 1} as SkillDbEntry);
						break;
					}
					case LanguageEnum.EN: {
						skills.push({skillNameEn: item, level: 1} as SkillDbEntry);
						break;
					}
					default: {
						skills.push({skillNameAlt: item, level: 1} as SkillDbEntry);
						break;
					}
				}
			}
			if (skills.length > 0) {
				this.formGroups.f1CustomerData.controls.internalSkillset.setValue([
					...skills,
					...this.formGroups.f1CustomerData.controls.internalSkillset.value.filter(
						(preexistingSkill) =>
							!skills.find((newSkill) => {
								preexistingSkill.skillNameDe === newSkill.skillNameDe;
								preexistingSkill.skillNameEn === newSkill.skillNameEn;
								preexistingSkill.skillNameAlt === newSkill.skillNameAlt;
							}),
					),
				]);
				this.formGroups.f1CustomerData.controls.internalSkillset.markAsDirty();
				this.onSkillsLoad.emit({
					logicalOperator: this.formGroups.f1CustomerData.controls.skillOperator.value,
					skillDbRows: this.formGroups.f1CustomerData.controls.internalSkillset.value,
				} as RedesignSkillDbFilterData);
			}
			this.loading = false;
		}
	}

	async gotoCapacityOverview() {
		const queryParams: Params = {capaRelevance: "ONLY_RELEVANT"};
		if (await this._customizingService.getCapacityOverViewCheckBoxHideExternalDefault()) {
			queryParams["employeeStatus"] = "ACTIVE";
		}
		this.openInNewTab("/employee-capacities", queryParams);
	}

	goToInstanceWideSearch() {
		this.openInNewTab("/instance-wide-search", {ignoreMinCapacity: true});
	}

	/**
	 * Öffnet die Kollegensuche in einem neuen Tab. Die Listen ersetzen beim Laden aus der URL ihren Standardfilter,
	 * deshalb müssen die Standardfilter der jeweiligen Liste in `listDefaults` mitgegeben werden.
	 * Die Skills werden mit der in der Staffing-Anfrage gewählten Verknüpfung (UND/ODER) übernommen.
	 */
	private openInNewTab(path: string, listDefaults: Params) {
		const skillDbFilterData = {
			logicalOperator: this.formGroups.f1CustomerData.controls.skillOperator.value ?? "AND",
			skillDbRows: this.formGroups.f1CustomerData.controls.internalSkillset.value.map((value) => ({
				skillNameDe: value.skillNameDe,
				skillNameEn: value.skillNameEn,
				skillNameAlt: value.skillNameAlt,
				level: parseInt(value.level, 10),
			})),
			includeExpiredCertificates: false,
		};
		// Kein Geschäftsbereich-Filter: die Suche zeigt alle Mitarbeiter, auf die der Benutzer Zugriff hat.
		const queryParams: Params = {...listDefaults, skillDbFilterData: JSON.stringify(skillDbFilterData)};
		// serializeUrl liefert den Pfad ohne Base-Href; prepareExternalUrl ergänzt "/mep/" (Prod-Build).
		const url = this._location.prepareExternalUrl(
			this._router.serializeUrl(this._router.createUrlTree([path], {queryParams})),
		);
		window.open(url, "_blank");
	}

	deleteResourceRequest() {
		const dialogRef = this._dialog.open(ConfirmationDialogComponent, {
			disableClose: false,
			data: {
				messageKey: "mep.components.general.notification.delete-resource-request",
				params: {
					count: 1,
				},
			},
		});

		dialogRef.afterClosed().subscribe((value) => {
			if (value) {
				this._resourceRequestService.deleteResourceRequests([this.resourceRequest.id]).subscribe(() => {
					// Update DataSource
					this._messageService.add(
						this.translate.instant("mep.components.toasts.was-deleted", {entity: this.resourceRequest.requestTitle}),
						AlertEnum.SUCCESS,
					);

					this.canExit = true;
					this._router.navigate(["/resource-request-list/"]).then();
				});
			}
		});
	}

	convertToProject() {
		this._dialog.open(ProjectDataComponent, {
			width: "70%",
			height: "70%",
			data: {
				convertFromStaffingRequest: true,
				isAddMode: true,
				isReadonlyMode: false,
				init: this.initProjectDataComponent.bind(this),
			},
		});
	}

	askMephisto() {
		const staffingId = this.resourceRequest.origId;
		this._router.navigateByUrl("/chatbot", {state: {data: staffingId}});
	}

	async copyResourceRequest() {
		const dialogRef = this._dialog.open(ConfirmationDialogComponent, {
			disableClose: false,
			data: {
				messageKey: "mep.components.general.notification.copy-resource-request",
				params: {},
			},
		});
		dialogRef.afterClosed().subscribe(async (value) => {
			if (value) {
				try {
					this.loading = true;
					const origTitle = this.formGroups.f0Header.controls.requestTitle.value;
					const result = await firstValueFrom(
						this._resourceRequestService.cloneResourceRequest(this.resourceRequest.id, this.lang),
					);
					this._messageService.add(origTitle + this._lang("clone-success"), AlertEnum.SUCCESS);

					const navigateDialogRef = this._dialog.open(ConfirmationDialogComponent, {
						disableClose: false,
						data: {
							messageKey: "mep.components.general.notification.navigate-to-copy",
							params: {},
						},
					});

					navigateDialogRef.afterClosed().subscribe(async (navigate) => {
						if (navigate) {
							await this.breadCrumbsNavigationService.clearListFromStorage("resourceRequest");
							await this._router.navigateByUrl("/resource-request-list", {skipLocationChange: true});
							await this._router.navigate(["/resource-request-list/" + result.resourceRequestDTO.id]);
						}
					});
				} catch (e) {
					console.error("Error cloning resource request:", e);
				} finally {
					this.loading = false;
				}
			}
		});
	}

	async shareStaffing() {
		let shareData: ShareData = {
			title: "Staffing Anfrage: " + this.resourceRequest.id,
			text: this.resourceRequest.requestTitle,
			url: window.location.href,
		};

		let shareFailed = false;

		if (!navigator.canShare || !navigator.canShare(shareData)) {
			shareFailed = true;
		}
		await navigator.share(shareData).catch(() => (shareFailed = true));

		if (shareFailed) {
			await navigator.clipboard.writeText(shareData.url).then(
				() => {
					this._messageService.add(this._lang("filter-copied"), AlertEnum.SUCCESS);
				},
				(reason) => {
					console.warn("Clipboard write Failed, reason: ", reason);
				},
			);
		}
	}

	async initProjectDataComponent(pdc: ProjectDataComponent) {
		const addEmployeesToProjectData = {
			employees: this.lists.offers as Employee[],
			capacity: this.formGroups.f2FrameData.value.scope,
			effectiveFrom: this.formGroups.f0Header.value.commitmentStart,
			effectiveUntil: this.formGroups.f0Header.value.commitmentEnd,
			addEmployeeForm: true,
		};
		pdc.project.client = this.formGroups.f1CustomerData.controls.client.value;
		pdc.project.status = ProjectStatus.ACTIVE;
		pdc.projectProbabilitiesDataSource.data[0]
			.get("effectiveFrom")
			.setValue(this.formGroups.f0Header.value.commitmentStart);
		pdc.projectProbabilitiesDataSource.data[0]
			.get("effectiveUntil")
			.setValue(this.formGroups.f0Header.value.commitmentEnd);
		pdc.project.projectLeader = await firstValueFrom(
			this._employeeService.getEmployeeById(this.formGroups.f3InternalHistory.value.responsibleDE.id),
		);
		pdc.project.description = this.formGroups.f1CustomerData.value.skillDescriptionOfCustomer;
		pdc.project.projectName = this.formGroups.f0Header.value.requestTitle;
		pdc.project.offer = this.formGroups.f1CustomerData.value.offer;
		pdc.projectDataInput.fields.toArray().forEach((value) => value.control.markAsTouched());
		pdc.formGroup.get("effectiveFrom").setValue(this.formGroups.f0Header.value.commitmentStart);
		pdc.formGroup.get("effectiveUntil").setValue(this.formGroups.f0Header.value.commitmentEnd);
		pdc.employeesToProjectDataSource.data = this.formGroups.f3InternalHistory.value.offered;
		pdc.activateEditMode();
		if (
			this.formGroups.f0Header.value.commitmentEnd &&
			this.formGroups.f0Header.value.commitmentStart &&
			this.formGroups.f3InternalHistory.value.offered.length
		) {
			pdc.addEmployeeToProjectElement = addEmployeesToProjectData;
			await pdc.addEmployees(addEmployeesToProjectData);
		}
		pdc.addEmployeeToProjectElement = addEmployeesToProjectData;
		await pdc.addEmployees(addEmployeesToProjectData);
	}

	async updateNumberOfPersonDays(fromHTML: boolean = true) {
		if (fromHTML && !this.addMode) {
			return;
		}
		if (
			!this.formGroups.f0Header.controls.commitmentStart.errors &&
			!this.formGroups.f0Header.controls.commitmentEnd.errors &&
			!this.formGroups.f1CustomerData.controls.requiredEmployees.errors &&
			!this.formGroups.f2FrameData.controls.scope.errors &&
			this.formGroups.f0Header.controls.commitmentStart.value &&
			this.formGroups.f0Header.controls.commitmentEnd.value &&
			this.formGroups.f1CustomerData.controls.requiredEmployees.value &&
			this.formGroups.f2FrameData.controls.scope.value &&
			!this.formGroups.f2FrameData.controls.totalScope.touched
		) {
			this.formGroups.f2FrameData.controls.totalScope.setValue(
				await firstValueFrom(
					this._resourceRequestService.getNumberOfPersonDaysForResourceRequest(
						moment(this.formGroups.f0Header.controls.commitmentStart.value).format("YYYY-MM-DD"),
						moment(this.formGroups.f0Header.controls.commitmentEnd.value).format("YYYY-MM-DD"),
						this.formGroups.f2FrameData.controls.scope.value,
						this.formGroups.f1CustomerData.controls.requiredEmployees.value,
					),
				),
				{emitEvent: false},
			);
		}
	}

	/**
	 * default behaviour emits app-redesign-skill-filter.skillOperator onclick
	 *
	 * @param $event
	 */
	preventDefault($event: KeyboardEvent) {
		if (($event.target as Element).tagName !== "TEXTAREA") {
			$event.preventDefault();
		}
	}

	toggleResourceRequestSaveMode() {
		this.isMultiResourceRequestSafeMode = !this.isMultiResourceRequestSafeMode;
	}

	private getEnums(enumPath: Record<string, string>): DropDownChoice<string>[] {
		return Object.keys(enumPath)
			.map((i) => ({value: i, viewValue: enumPath[i]}))
			.sort();
	}

	private getEnumsTranslated(enumPath: Record<string, string>): DropDownChoice<string>[] {
		return Object.keys(enumPath)
			.map((i) => ({value: i, viewValue: this._translate.instant(enumPath[i])}))
			.sort();
	}

	// eslint-disable-next-line @angular-eslint/contextual-lifecycle
	ngAfterViewInit(): void {
		this.rendered = true;
		setTimeout(() => {
			const collection = document.getElementsByClassName("mat-step-header mat-horizontal-stepper-header");

			if (collection.length > 0) {
				const leftArrow = document.getElementById("nav-button-left");
				const rightArrow = document.getElementById("nav-button-right");

				if (leftArrow && rightArrow) {
					const container = collection.item(0).parentNode;

					this.renderer.insertBefore(container, leftArrow, collection.item(0));
					this.renderer.appendChild(container, rightArrow);

					this.updateStepArrowsVisibility();
				}
			}
		}, 1000);

		this.stepper.selectionChange.subscribe(() => {
			setTimeout(() => {
				this.updateStepArrowsVisibility();
			}, 0);
		});
	}

	previousStep() {
		this.stepper.previous();
		this.updateStepArrowsVisibility();
	}

	nextStep() {
		this.stepper.next();
		this.updateStepArrowsVisibility();
	}

	async refreshPermissions() {
		this.permissions = {
			isForeignBUsRR: false,
			isOtherInstance: false,
			hasInterestedBUWritePermissionsOnly: false,
			hasGeneralWritePermissions: false,
			hasReadOnConfidentialFields: true,
			showExperimentalMEPTextextraction: false,
			isAdmin: false,
		};
	}

	async moveFromNavigation(rrId: number): Promise<void> {
		await this._router.navigateByUrl("/resource-request-list", {skipLocationChange: true});
		await this._router.navigate(["/resource-request-list/" + rrId]);
	}

	async disableFieldsBasedOnPermissionAndDispoFlag() {
		let isInterestedResponsible: boolean;
		if (this.currentUser.employee == null) {
			isInterestedResponsible = false;
		} else {
			isInterestedResponsible = this.resourceRequest.interestedResponsible?.some(
				(interested) => interested.id === this.currentUser.employee.id,
			);
		}

		if (!this.resourceRequest.dispoFlag) {
			delete this.allowedControls["businessUnits"];
		}

		if (
			!this.resourceRequest.dispoFlag &&
			this.permissions.hasInterestedBUWritePermissionsOnly &&
			!isInterestedResponsible &&
			!this.checkIfUserHasInterestedBu(false)
		) {
			this.formGroups.f3InternalHistory.controls.responsibleDE.setValue("-");
		}
	}

	updateStepArrowsVisibility() {
		const leftArrow = document.getElementById("nav-button-left");
		const rightArrow = document.getElementById("nav-button-right");

		if (this.stepper.selectedIndex === 0) {
			this.renderer.setStyle(leftArrow, "display", "none");
		} else {
			this.renderer.removeStyle(leftArrow, "display");
			leftArrow.style.removeProperty("display");
		}

		if (this.stepper.selectedIndex === this.stepper._steps.length - 1) {
			this.renderer.setStyle(rightArrow, "display", "none");
		} else {
			this.renderer.removeStyle(rightArrow, "display");
			rightArrow.style.removeProperty("display");
		}
	}

	openMailDialogGlobal() {
		NotifyResponsibleDialogComponent.open(
			this._dialog,
			this.resourceRequest.origId,
			this.resourceRequest.requestTitle,
			this.resourceRequest.id,
			(message, cc?: string) =>
				this._resourceRequestService.sendMailToResponsible(
					this.resourceRequest.origId,
					this.instanceNameOfRR,
					message,
					cc,
				),
		);
	}

	formatDateToMonthYear(date: string): string {
		return this.datePipe.transform(date, "MMM yyyy", undefined, "en-US")?.toUpperCase() || "";
	}

	setCapacityParameters(
		startDate: string,
		months: number,
		viewType: MisplannedCapacityEnum,
		planned: boolean,
		operativOnly: boolean,
		concrete: boolean,
		showInPercent: boolean = false,
	) {
		return {
			startDate: startDate ? moment(startDate, "yyyy-MM-dd") : moment(),
			months: months,
			viewType: viewType,
			planned: planned,
			operativOnly: operativOnly,
			concrete: concrete,
			showInPercent: showInPercent,
		};
	}

	private async getCountryOfStaffing() {
		const countries = await firstValueFrom(this._countryService.getAllCountries());

		let x = countries
			.filter((country) => country.enumName !== Config.services.missingValueBackend)
			.map(
				(country) =>
					({
						value: country.countryEn.toUpperCase().replace(/ /g, "_"),
						viewValue: country.enumName + " - " + (this.lang === "en" ? country.countryEn : country.countryDe),
					}) as DropDownChoice<string>,
			)
			.sort((a, b) => a.viewValue.localeCompare(b.viewValue));

		x = [
			{
				value: "NO_MATTER",
				viewValue: this._translate.instant(Config.services.resource_request.staffingLocation.NO_MATTER),
			},
			...x,
		];

		return x;
	}

	async preAssignValuesFromProjectDetails(project: Project, selectedAssignment?: AssignmentProjectEmployee) {
		const currentUser = await this._authService.getApplicationUser();
		const loginUser = currentUser.employee;

		this.formGroups.f0Header.controls["requestTitle"].setValue(project.projectName);
		this.formGroups.f1CustomerData.controls["client"].setValue(project.client);
		this.formGroups.f1CustomerData.controls["currentProject"].setValue(project);
		this.formGroups.f1CustomerData.controls["skillDescriptionOfCustomer"].setValue(
			project.description || `${project.client} - ${project.projectName}`,
		);
		this.formGroups.f1CustomerData.controls["offer"].setValue(`Projekt-ID:${project.sharePointId}`);
		this.formGroups.f2FrameData.controls["requestedBy"].setValue(`${loginUser.lastName}, ${loginUser.firstName}`);
		this.formGroups.f3InternalHistory.controls["responsibleBusinessUnit"].setValue(loginUser.businessUnit);
		this.formGroups.f3InternalHistory.controls["responsibleDE"].setValue(loginUser);
		this.formGroups.f2FrameData.controls["scope"].setValue(100);

		if (selectedAssignment) {
			this.formGroups.f0Header.controls["requestTitle"].setValue(`${project.client} - ${project.projectName}`);
			this.formGroups.f1CustomerData.controls["role"].setValue(selectedAssignment.role);
			this.formGroups.f1CustomerData.controls["requiredEmployees"].setValue(1);

			this.formGroups.f1CustomerData.controls["skillDescriptionOfCustomer"].setValue(
				`Projekt: ${project.description || `${project.client} - ${project.projectName}`}\n` +
					`Zusätzliches Staffing basierend auf Mitarbeiter ${selectedAssignment.employee.lastName}, ${selectedAssignment.employee.firstName}`,
			);
			const offerParts = [`Projekt-ID:${project.sharePointId}`];
			if (selectedAssignment.workPackage) {
				offerParts.push(`Work_Package:${selectedAssignment.workPackage}`);
			}
			if (selectedAssignment.workItem) {
				offerParts.push(`WorkItem:${selectedAssignment.workItem}`);
			}
			offerParts.push(`MA:${selectedAssignment.employee.personnelNumber}`);
			this.formGroups.f1CustomerData.controls["offer"].setValue(offerParts.join(";"));

			this._employeeService
				.getEmployeeSkillsById(selectedAssignment.employee.id)
				.subscribe((employeeSkills: EmployeeSkill[]) => {
					this.selectedSkills = employeeSkills
						.filter((s) => s.coreCompetence)
						.map((s) => ({
							skillNameDe: s.skill.skillNameDe,
							skillNameEn: s.skill.skillNameEn,
							skillNameAlt: s.skill.skillNameAlt,
							level: s.experienceLevel === "X" ? 1 : Number(s.experienceLevel),
						}));
				});
		}
	}
}
